import { render, staticRenderFns } from "./LeaderShipSurveySettings.vue?vue&type=template&id=4b2b0335&"
import script from "./LeaderShipSurveySettings.vue?vue&type=script&lang=js&"
export * from "./LeaderShipSurveySettings.vue?vue&type=script&lang=js&"
import style0 from "./LeaderShipSurveySettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports